import React, { Component } from 'react';

// A sampled plan view for interactive manual review. It never edits the design.
export default class CloudAlignmentPreview extends Component {
    componentDidMount() { this.draw(); }
    componentDidUpdate() { this.draw(); }
    draw() {
        const { data, adjustment } = this.props;
        if (!this.canvas || !data) return;
        const ctx = this.canvas.getContext('2d'); if (!ctx) return;
        const a = adjustment.rotation * Math.PI / 180, c = Math.cos(a), s = Math.sin(a), [px, py] = adjustment.pivot;
        const cloud = data.cloud.map(p => { const x=p[0]-px,y=p[1]-py; return [c*x-s*y+px+adjustment.east,s*x+c*y+py+adjustment.north]; });
        const all = [...data.design, ...cloud]; if (!all.length || all.some(p => !Number.isFinite(p[0]) || !Number.isFinite(p[1]))) return;
        const xs=all.map(p=>p[0]),ys=all.map(p=>p[1]),minX=Math.min(...xs),maxX=Math.max(...xs),minY=Math.min(...ys),maxY=Math.max(...ys);
        const scale=Math.min(680/Math.max(1,maxX-minX),320/Math.max(1,maxY-minY)),cx=(minX+maxX)/2,cy=(minY+maxY)/2;
        ctx.fillStyle='#142331';ctx.fillRect(0,0,720,360);
        const draw=(points,color)=>{ctx.fillStyle=color;points.forEach(p=>ctx.fillRect(360+(p[0]-cx)*scale,180-(p[1]-cy)*scale,2,2));};
        draw(data.design,'#ffbd69');draw(cloud,'#67dcec');
        ctx.fillStyle='white';ctx.font='13px sans-serif';ctx.fillText('North ↑   ·   '+(100/scale).toFixed(1)+' m per 100 px',12,20);
    }
    render() { return <figure><canvas ref={node=>{this.canvas=node;}} width="720" height="360" style={{width:'100%',height:'auto'}} aria-label="Sampled cloud and fixed design preview" /><figcaption>Plan view: orange = fixed design; cyan = adjusted cloud. Sampled geometry for review; height changes are applied to the saved 3D view.</figcaption></figure>; }
}
